import "../Assets/css/general/form.css"
import Navbar from "../Atoms/navbar";
import contactjson from "../Assets/json/contact.json"
import footerjson from "../Assets/json/footer.json"
import Map from "../Atoms/map";

export default function Service({lg}){
  return(
    <>
      <Navbar lg={lg}/>
      <div className="formopt">
      <div className="welcome_heading pt-4">   
        <p>{footerjson[0][lg][0].links[0].link2}</p>
      </div>
        <div className="form row py-2 formcont">
          <div className="col-lg-6 px-5 formmap">
            <Map/>
          </div>
          <div className="form-field-section col-lg-6 px-5">
            <div className="form-head">{contactjson[0][lg][0].heading}</div>
            <form id="contact-form" className="contact-form" action="contactmail.php" method="post">
              <input type="text" name="name" placeholder={contactjson[0][lg][0].field1} className="form-control input-focus-none mt-4" id="InputName" required/>
              
              <input type="text" name="number" placeholder={contactjson[0][lg][0].field2} className="form-control mt-4" id="InputMob" required/>
              
              <input type="email" name="email" placeholder={contactjson[0][lg][0].field3} className="form-control mt-4" id="InputEmail"/>
              
              <input type="text" name="usersubject" placeholder={contactjson[0][lg][0].field4} className="form-control mt-4" id="InputSubject" />
              <textarea id="InputMessage" className="form-control mt-4" name="usermessage" rows="4" placeholder={contactjson[0][lg][0].field5}/>
              <button type="submit" className="btn btn-warning mb-3 mt-4 px-4 form-btn" name="submit">{contactjson[0][lg][0].button}</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}